import React, { useState } from "react";
import "../assets/AgentCommission.css";

const AgentCommission = () => {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    agent: "",
    branch: "",
    product: "",
    status: "",
  });

  const dummyData = [
    {
      date: "2025-06-15",
      agent: "Rajesh Kumar",
      branch: "Mumbai",
      product: "Loan",
      customer: "Amit Sharma",
      amount: 100000,
      fixed: 500,
      percent: 1.5,
      status: "Paid",
    },
    {
      date: "2025-06-15",
      agent: "Anjali Sharma",
      branch: "Delhi",
      product: "Insurance",
      customer: "Neha Singh",
      amount: 50000,
      fixed: 300,
      percent: 2.0,
      status: "Unpaid",
    },
  ];

  const getCommissionAmount = (d) => d.fixed + (d.amount * d.percent) / 100;

  const filteredData = dummyData.filter((item) => {
    const f = filters;
    return (
      (!f.agent || item.agent.toLowerCase().includes(f.agent.toLowerCase())) &&
      (!f.branch || item.branch.toLowerCase().includes(f.branch.toLowerCase())) &&
      (!f.product || item.product === f.product) &&
      (!f.status || item.status === f.status)
    );
  });

  const totalCommission = filteredData.reduce((acc, d) => acc + getCommissionAmount(d), 0);

  return (
    <div className="AgentCommission-container">
      <h2 className="AgentCommission-title">Agent Commission Dashboard</h2>

      {/* Summary Cards */}
      <div className="AgentCommission-summary">
        <div className="AgentCommission-card card-blue">
          <h4>Total Agents</h4>
          <p>{[...new Set(dummyData.map((d) => d.agent))].length}</p>
        </div>
        <div className="AgentCommission-card card-green">
          <h4>Total Commission</h4>
          <p>₹{totalCommission.toFixed(2)}</p>
        </div>
        <div className="AgentCommission-card card-yellow">
          <h4>Paid</h4>
          <p>
            ₹{dummyData
              .filter((d) => d.status === "Paid")
              .reduce((acc, val) => acc + getCommissionAmount(val), 0)
              .toFixed(2)}
          </p>
        </div>
        <div className="AgentCommission-card card-red">
          <h4>Unpaid</h4>
          <p>
            ₹{dummyData
              .filter((d) => d.status === "Unpaid")
              .reduce((acc, val) => acc + getCommissionAmount(val), 0)
              .toFixed(2)}
          </p>
        </div>
      </div>

      {/* Filter Section */}
      <div className="AgentCommission-filters">
        <input
          type="date"
          value={filters.fromDate}
          onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
        />
        <input
          type="date"
          value={filters.toDate}
          onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
        />
        <input
          type="text"
          placeholder="Agent Name"
          value={filters.agent}
          onChange={(e) => setFilters({ ...filters, agent: e.target.value })}
        />
        <input
          type="text"
          placeholder="Branch"
          value={filters.branch}
          onChange={(e) => setFilters({ ...filters, branch: e.target.value })}
        />
        <select
          value={filters.product}
          onChange={(e) => setFilters({ ...filters, product: e.target.value })}
        >
          <option value="">All Products</option>
          <option value="Loan">Loan</option>
          <option value="Insurance">Insurance</option>
          <option value="Savings">Savings</option>
        </select>
        <select
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
        >
          <option value="">All Status</option>
          <option value="Paid">Paid</option>
          <option value="Unpaid">Unpaid</option>
        </select>
      </div>

      {/* Table */}
      <div className="AgentCommission-tableWrapper">
        <table className="AgentCommission-table">
          <thead>
            <tr>
              <th>S.N</th>
              <th>Date</th>
              <th>Agent</th>
              <th>Branch</th>
              <th>Product</th>
              <th>Customer</th>
              <th>Amount</th>
              <th>Fixed</th>
              <th>%</th>
              <th>Total Commission</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.agent}</td>
                  <td>{item.branch}</td>
                  <td>{item.product}</td>
                  <td>{item.customer}</td>
                  <td>₹{item.amount}</td>
                  <td>₹{item.fixed}</td>
                  <td>{item.percent}%</td>
                  <td>₹{getCommissionAmount(item).toFixed(2)}</td>
                  <td>
                    <span className={`AgentCommission-status ${item.status.toLowerCase()}`}>
                      {item.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="AgentCommission-noData">No records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgentCommission;
